import axios from 'axios'

// Dashboard version history / restore API.
// See docs/dashboard-versioning-design.md section 8 and users/views.py
// (DashboardVersionListView, DashboardVersionPreviewView,
// DashboardVersionRestoreView). Owner-only on the server; all three throw a
// 403/404 for anyone else.

const authConfig = (access) => ({
  headers: {
    'Content-type': 'application/json',
    Authorization: `Bearer ${access}`,
  },
})

const versionsUrl = (code) => `/api/v1/dashboard/${code}/versions/`

// Response: [{ version, created_at, updated_at, author, restored_from, label,
//   summary: { widget_count, added, removed, moved, content_edited } }, ...]
// newest first.
export const listDashboardVersions = (code, access) => (
  axios.get(versionsUrl(code), authConfig(access)).then(response => response.data)
)

// Response: { version, widgets: [{ uid, widget_type, title, x, y, w, h }, ...] }
// Never widget content — ghost-box geometry + a derived title only.
export const previewDashboardVersion = (code, version, access) => (
  axios.get(`${versionsUrl(code)}${version}/preview/`, authConfig(access)).then(response => response.data)
)

// Response: { restored, hidden, content_reverted, current_version }.
// Requires the caller to currently hold the dashboard's edit lock — the
// server 409s with { code: 'lock_lost' } otherwise.
export const restoreDashboardVersion = (code, version, access, lockSessionId) => (
  axios.post(
    `${versionsUrl(code)}${version}/restore/`,
    { lock_session_id: lockSessionId },
    authConfig(access),
  ).then(response => response.data)
)
